








import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
@Component({
  components: {}
})
export default class CoinsTitle extends Vue {
  @Prop({ default: 0 })
  private number: any;
  @Prop({ default: true })
  private border?: boolean;
}
